module.exports = __webpack_public_path__ + "static/travel404-b785f6147de0a59d582423bf7cf40a00.svg";